__turbopack_context__.v({
  "chatThreadAside": "ClientChatThreadAside-module__ewCERq__chatThreadAside",
  "chatThreadAsideAnimation": "ClientChatThreadAside-module__ewCERq__chatThreadAsideAnimation",
  "chatThreadAside__Content": "ClientChatThreadAside-module__ewCERq__chatThreadAside__Content",
  "chatThreadAside__Header": "ClientChatThreadAside-module__ewCERq__chatThreadAside__Header",
  "chatThreadAside__off": "ClientChatThreadAside-module__ewCERq__chatThreadAside__off",
  "chatThreadGuideFade": "ClientChatThreadAside-module__ewCERq__chatThreadGuideFade",
});
